<template>
  <div class="insight-content-overlay" :class="{ visible: showOpenAiResponse }">
    <div class="insight-content-container">
      <div class="insight-header">
        <img
          src="/i-SET.png"
          alt="Logo"
          class="insight-logo"
        />
        <div class="insight-title-container">
          <span class="insight-title">Análise do SET</span>
        </div>
        <button class="close-button" @click="$emit('close')">
          <span>&times;</span>
        </button>
      </div>

      <!-- Loading Skeletons -->
      <div class="insight-content-body" v-if="isLoadingInsights">
        <div class="skeleton-container">
          <Skeleton width="100%" height="40px" class="mb-2"></Skeleton>
          <Skeleton width="80%" height="30px" class="mb-2"></Skeleton>
          <Skeleton width="100%" height="20px" class="mb-1"></Skeleton>
          <Skeleton width="100%" height="20px" class="mb-1"></Skeleton>
          <Skeleton width="90%" height="20px" class="mb-1"></Skeleton>
          <Skeleton width="100%" height="20px" class="mb-3"></Skeleton>
          
          <Skeleton width="70%" height="30px" class="mb-2"></Skeleton>
          <Skeleton width="100%" height="20px" class="mb-1"></Skeleton>
          <Skeleton width="100%" height="20px" class="mb-1"></Skeleton>
          <Skeleton width="85%" height="20px" class="mb-3"></Skeleton>
        </div>
      </div>

      <!-- Content -->
      <div class="insight-content-body" v-if="!isLoadingInsights">
        <div v-for="insight in insightsToShow" :key="insight.id" class="insight-item">
          <h2 class="insight-group-title">{{ insight.topic }}</h2>
          <h3 class="insight-item-title">{{ extractTitle(insight.insight) }}</h3>
          <div
            v-for="(textItem, index) in parseEnumeratedText(insight.insight)"
            :key="index"
            class="insight-text-block"
          >
            <p class="insight-text">{{ textItem }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Skeleton from 'primevue/skeleton'
import Button from 'primevue/button'
import ProgressSpinner from 'primevue/progressspinner'

export default {
  name: 'InsightsContent',
  components: {
    Skeleton,
    Button,
    ProgressSpinner
  },
  props: {
    module: {
      type: String,
      required: true
    },
    showOpenAiResponse: {
      type: Boolean,
      required: true
    },
    isLoadingInsights: {
      type: Boolean,
      required: true
    },
    isUploadingInsights: {
      type: Boolean,
      required: true
    },
    insightsToShow: {
      type: Array,
      default: () => []
    },
    extractTitle: {
      type: Function,
      required: true
    },
    parseEnumeratedText: {
      type: Function,
      required: true
    }
  }
}
</script>

<style scoped>
.insight-content-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000 !important;
  overflow: hidden;
  pointer-events: all !important;
}

.insight-content-overlay.visible {
  display: flex;
  align-items: center;
  justify-content: center;
}

.insight-content-container {
  position: relative;
  width: 90%;
  max-width: 1000px;
  height: 90%;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.insight-header {
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}

.insight-logo {
  width: 180px;
}

.insight-title-container {
  display: flex;
  align-items: center;
  gap: 15px;
}

.insight-title {
  font-size: 24px;
  font-weight: 600;
  color: #111827;
}

.update-button {
  display: flex;
  align-items: center;
  gap: 8px;
}

.close-button {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.close-button:hover {
  background-color: #f3f4f6;
  color: #1f2937;
}

.insight-content-body {
  flex: 1;
  padding: 20px 30px;
  overflow-y: auto;
}

.skeleton-container {
  padding: 15px;
}

.insight-item {
  margin-bottom: 30px;
}

.insight-group-title {
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 15px;
}

.insight-item-title {
  font-size: 18px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 10px;
}

.insight-text-block {
  background-color: #f9fafb;
  border-left: 3px solid #1c3d5a;
  border-radius: 4px;
  padding: 12px 15px;
  margin-bottom: 10px;
}

.insight-text {
  font-size: 15px;
  line-height: 1.6;
  color: #4b5563;
  margin: 0;
}
</style> 